import { gql } from '@apollo/client'
import { PRODUCT_PRICE_FRAGMENT } from './ProductPriceFragment'
import { AUDIT_SCORE_FRAGMENT } from './ScoreFragments'
import { AUDIT_ANSWER_FRAGMENT } from './AuditAnswerFragment'
import { CR_COUNT_ITEM_FRAGMENT } from './CRCountItemFragment'
import { ADMIN_WHOLE_DISPLAY_AUDIT_FRAGMENT } from './AdminWholeDisplayAuditFragment'

export const ADMIN_WHOLE_AUDIT_FRAGMENT = gql`
  fragment AdminWholeAudit on Audit {
    id
    created
    saved
    dateCompleted
    displaysCompletedAt
    pricingCompletedAt
    surveyCompletedAt
    employee {
      firstName
      lastName
      id
      email
    }
    store {
      id
      storeChain
      name
      hasAllFormulas
      address {
        address1
        city
        state
        postalCode
      }
    }
    status
    score {
      ...AuditScore
    }
    notes
    auditAnswers {
      ...AuditAnswer
    }
    displayAudits {
      ...AdminWholeDisplayAudit
    }
    crCountItems {
      ...CRCountItem
    }
    productPrices {
      ...ProductPrice
    }
  }
  ${AUDIT_ANSWER_FRAGMENT}
  ${AUDIT_SCORE_FRAGMENT}
  ${ADMIN_WHOLE_DISPLAY_AUDIT_FRAGMENT}
  ${PRODUCT_PRICE_FRAGMENT}
  ${CR_COUNT_ITEM_FRAGMENT}
`
